export default __webpack_public_path__ + "assets/images/graphROI9-e1980438ccf6e556c240d3d54a6bcde0.png";